<div class="warehouse-search-dropdown__wrapper">
  <input
    [class]="inputClass"
    [placeholder]="selectedItem?.location_name || selectedItem?.locationName || ''"
    [formControl]="searchControl"
    [matAutocomplete]="auto"
    (focus)="getRecords()"
    #searchInput
  />
  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displaySelectedItem"
    [infiniteScrollFetchingData]="(loadingRecords$ | async) || false"
    (lumInfiniteScroll)="getRecords()"
    (optionSelected)="onSelectItem($event)"
    (closed)="onClosePanel()"
  >
    <mat-option *ngFor="let row of records; trackBy: trackById" [value]="row">
      {{ row?.location_name || row?.locationName || '' }}
    </mat-option>
    <mat-option *ngIf="loadingRecords$ | async">
      <mat-progress-spinner
        class="progress-spinner"
        diameter="16"
        mode="indeterminate"
      ></mat-progress-spinner>
    </mat-option>
    <mat-option
      *ngIf="!records.length && !(loadingRecords$ | async)"
      [disabled]="true"
    >
      No records found
    </mat-option>
  </mat-autocomplete>
  <button
    *ngIf="clearable && selectedItem && !(loadingRecords$ | async)"
    mat-icon-button
    type="button"
    aria-label="Clear"
    class="clear-button"
    (click)="onRemoveItem()"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
